/**
 * Upload files directly to S3 using presigned URLs
 * 
 * @param {Array} files - Array of File objects from input
 * @param {Array} presignedUrls - Array of presigned URL objects from Lambda
 * @param {Function} onProgress - Optional callback for progress updates
 * @returns {Array} - Array of uploaded file info with S3 keys
 */
export async function uploadFilesToS3(files, presignedUrls, onProgress = null) {
  const uploadResults = [];
  
  for (let i = 0; i < files.length; i++) {
    const file = files[i];
    const presignedData = presignedUrls[i];
    
    try {
      // Upload to S3 using presigned URL
      const response = await fetch(presignedData.url, {
        method: 'PUT',
        body: file,
        headers: {
          'Content-Type': file.type
        }
      });
      
      if (!response.ok) {
        throw new Error(`Upload failed for ${file.name}: ${response.statusText}`);
      }
      
      // Track successful upload
      uploadResults.push({
        s3Key: presignedData.s3Key,
        fileName: presignedData.fileName,
        fileType: presignedData.fileType
      });
      
      // Report progress if callback provided
      if (onProgress) {
        onProgress({
          current: i + 1,
          total: files.length,
          fileName: file.name
        });
      }
      
      console.log(`Uploaded ${file.name} to S3:`, presignedData.s3Key);
      
    } catch (error) {
      console.error(`Failed to upload ${file.name}:`, error);
      throw error;
    }
  }
  
  return uploadResults;
}